export function trigger() {
  const triggerContent = document.querySelector('.trigger-content');
  if(triggerContent) {
    triggerContent.addEventListener('click', function(e) {
      document.body.classList.remove('is-description-active', 'is-spec-active');
      if(!document.body.classList.contains('is-content-active')){
        document.body.classList.add('is-content-active');
      } else {
        document.body.classList.remove('is-content-active');
      }
      e.preventDefault();
    });
  }

  const triggerDescription = document.querySelector('.trigger-description');
  if(triggerDescription) {
    triggerDescription.addEventListener('click', function(e) {
      document.body.classList.remove('is-content-active', 'is-spec-active');
      if(!document.body.classList.contains('is-description-active')){
        document.body.classList.add('is-description-active');
      } else {
        document.body.classList.remove('is-description-active');
      }
      e.preventDefault();
    });
  }

  const triggerSpec = document.querySelector('.trigger-spec');
  if(triggerSpec) {
    triggerSpec.addEventListener('click', function(e) {
      document.body.classList.remove('is-content-active', 'is-description-active');
      if(!document.body.classList.contains('is-spec-active')){
        document.body.classList.add('is-spec-active');
      } else {
        document.body.classList.remove('is-spec-active');
      }
      e.preventDefault();
    });
  }

  const triggerReset = document.querySelectorAll('.trigger-reset');
  if(triggerReset.length) {
    for (let i = 0; i < triggerReset.length; i++) {
      const el = triggerReset[i];
      el.addEventListener('click', function(e) {
        document.body.classList.remove('is-content-active','is-description-active','is-spec-active');
        e.preventDefault();
      });
    }
  }
}